export default 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ' +
    'Vestibulum at pellentesque nisl, sit amet aliquet nisi. Phasellus vitae ' +
    'viverra eros.'
